var _path, _path2, _path3, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTroubleshootPlatformSpecificIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 85,
    viewBox: "0 0 102 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.9999 26.7017V8.17537C77.9999 4.7651 75.2636 1.99999 71.8887 1.99999H29.1112C27.4901 1.99999 25.9364 2.64995 24.7905 3.80938C23.6432 4.96728 23 6.5374 23 8.17537V45.228V68.7246V82.4746",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.7782 2.0002H35.2227V3.41203C35.2227 5.05018 35.866 6.62031 37.0132 7.7782C38.159 8.93764 39.7128 9.58759 41.3339 9.58759H59.667C61.2881 9.58759 62.8419 8.93764 63.9877 7.7782C65.1349 6.62031 65.7782 5.05018 65.7782 3.41203V2.0002Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M78 82.5L78 26.3299",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 1.5,
    y1: 83.5,
    x2: 100.5,
    y2: 83.5,
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTroubleshootPlatformSpecificIcon);
export default __webpack_public_path__ + "static/media/troubleshoot_platform_specific_icon.abc2f24310b8d276d7d00c4533004a40.svg";
export { ForwardRef as ReactComponent };